import PropTypes from 'prop-types';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import ReactPlayer from 'react-player';
import Image from 'src/components/image';

const ScreenRecordings = ({ screenRecordings }) => {
  // variables
  const isFirefox = typeof InstallTrigger !== 'undefined';

  // functions
  const handleDownload = async (videoUrl, fileName) => {
    const response = await fetch(videoUrl);
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    screenRecordings.length !== 0 && (
      <Accordion
        sx={{ padding: '0rem 1.2rem' }}
        disabled={false}
        defaultExpanded
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <p
            style={{
              fontSize: '1.2rem',
              fontWeight: '600',
              margin: '0px',
              padding: '0px',
            }}
          >
            Candidate&apos;s Screen Recording
          </p>
        </AccordionSummary>
        {!isFirefox && screenRecordings && screenRecordings.length && (
          <AccordionDetails>
            <Stack
              sx={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                gap: '1rem',
              }}
            >
              {screenRecordings.map(
                (recording, ind) =>
                  recording.screen_recording_url !== '' && (
                    <Paper
                      key={ind}
                      sx={{
                        borderRadius: 1,
                        position: 'relative',
                      }}
                    >
                      <Stack sx={{ pb: 0.5 }}>
                        <ReactPlayer
                          width="240px"
                          height="142px"
                          // style={{height:"100px"}}
                          controls
                          url={recording.screen_recording_url}
                        />
                        <Typography
                          sx={{ textAlign: 'center', fontWeight: '600' }}
                        >
                          {`Q ${ind + 1}`}
                        </Typography>
                      </Stack>
                    </Paper>
                  ),
              )}
            </Stack>
          </AccordionDetails>
        )}

        {isFirefox && screenRecordings && screenRecordings.length && (
          <AccordionDetails>
            <Stack
              sx={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                gap: '1rem',
              }}
            >
              {screenRecordings.map(
                (recording, ind) =>
                  recording.screen_recording_url !== '' && (
                    <Paper
                      key={ind}
                      sx={{
                        mr: 3,
                        borderRadius: 1,
                        position: 'relative',
                        cursor: 'pointer',
                      }}
                      onClick={() =>
                        handleDownload(
                          recording.screen_recording_url,
                          'screen_recording',
                        )
                      }
                    >
                      <Stack alignItems="center" sx={{ pb: 0.5 }}>
                        <Image
                          src="/assets/images/thumbnail.jpg"
                          sx={{
                            width: 150,
                            height: 100,
                            borderRadius: 1.5,
                          }}
                          alt="image"
                        />
                        <Typography
                          sx={{ textAlign: 'center', fontWeight: '600' }}
                        >
                          {`Q ${ind + 1}`}
                        </Typography>
                      </Stack>
                    </Paper>
                  ),
              )}
            </Stack>
          </AccordionDetails>
        )}
      </Accordion>
    )
  );
};

ScreenRecordings.propTypes = {
  screenRecordings: PropTypes.array,
};

export default ScreenRecordings;
